angular.module('am4').filter('uniqueByCmsKey', function() {
    return function(values) {
        if (!values) return values;
        var seen = {};
        return values.filter(function(val) {
            var key = val ? val.toUpperCase().replaceAll(' ', '_') : '';
            if (seen[key]) return false;
            seen[key] = true;
            return true;
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/uniqueByCmsKey.js